<template>
  <v-dialog
    v-model="dialog"
    max-width="700px"
  >
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="true"
      autocomplete="off"
    >
      <v-card>
        <v-card-title>
          <span class="headline font-weight-bold">Modifica Ricambio</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  label="Fornitore"
                  :items="suppliers"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.supplier_id"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.name"
                  label="Nome"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.model"
                  label="Modello"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  label="Stato"
                  :items="states"
                  v-model="editedItem.state"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.color"
                  label="Colore"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.cost"
                  label="Costo"
                  type="number"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.price"
                  label="Prezzo"
                  type="number"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.amount"
                  label="Quantità"
                  type="number"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="close"
          >Cancella</v-btn>
          <v-btn
            color="primary"
            text
            @click="save"
          >Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  import { mapMutations, mapGetters } from 'vuex'

  export default {
    name: 'EditForm',

    data() {
      return {
        editedItem: {},
        suppliers: [],
        valid: false,
        states: [
          'ORIGINALE',
          'COMPATIBILE'
        ],
        rules: {
          required: value => !!value || 'Campo obbligatorio.',
        },
        config: {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        },
      }
    },

    props: {
      item: { type: Object }
    },

    computed: {
      ...mapGetters([
        'getRicambiEdit'
      ]),
      dialog: {
        get() {
          return this.getRicambiEdit
        },
        set() {
          this.CHANGE_RICAMBI_EDIT(false)
        }
      }
    },

    methods: {
      ...mapMutations([
        'CHANGE_RICAMBI_EDIT'
      ]),

      async getSuppliers() {
        let { data } = await axios.get(`${process.env.VUE_APP_API}/suppliers`, this.config)

        this.suppliers = data
      },

      close() {
        this.CHANGE_RICAMBI_EDIT(false)
      },

      async save() {
        if (this.$refs.form.validate()) {

          this.$emit('edit-submit', 'reset')

          const { data } = await axios.post(`${process.env.VUE_APP_API}/replacements/update`, this.editedItem, this.config)

          if (data.status) {

            this.$emit('edit-submit', 'ok')
            this.close()
          } else {

            this.$emit('edit-submit', 'error')
          }
        }
      }
    },

    watch: {
      dialog(val) {
        val || this.close() && this.CHANGE_RICAMBI_EDIT(false)
      },
      item(val) {
        this.editedItem = val
      }
    },

    async mounted() {
      await this.getSuppliers()
    }
  }
</script>

<style>
</style>